<template>
  <div class="main-container">
      <div class="information hidden-sm-and-down">
          <div class="container">
              <div class="nav_1">
                <el-tabs type="card" style="padding:10% 0 50px 0" @tab-click="selectTab" v-model="orderslist">
                    <el-tab-pane label="我的信息" name="myinfo">
                    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="74px" class="demo-ruleForm">
                        <el-form-item label="手机号码">
                        <el-input v-model="ruleForm.userPhone" autocomplete="off" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名" prop="userName">
                        <el-input type="text" v-model="ruleForm.userName" ref="name" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="性别" prop="gender">
                        <el-radio-group v-model="ruleForm.gender" ref="gender">
                            <el-radio :label="1">男</el-radio>
                            <el-radio :label="2">女</el-radio>
                        </el-radio-group>
                        </el-form-item>
                        <el-form-item label="生日">
                        <div class="block">
                            <el-date-picker v-model="ruleForm.birthday" type="date" placeholder="选择日期" :editable="false" value-format="yyyy-MM-dd" ref="birthday" style="width:100%"></el-date-picker>
                        </div>
                        </el-form-item>
                        <el-form-item label="邮箱" prop="email">
                        <el-input type="email" v-model="ruleForm.email" autocomplete="off" ref="email"></el-input>
                        </el-form-item>
                        <el-button style="margin-left:13%;" v-on:click="submitForm(formData)" class="subbutton">提交</el-button>
                        <el-button v-on:click="outlogin()" class="subbutton">退出登录</el-button>
                    </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="收货地址">
                    <div>
                        <p v-show="addressData.length<=0" style="margin:25px 0 25px 0">您当前没有任何收货地址</p>
                        <div>
                        <el-card class="box-card" v-for="(index,item) in addressData" :key="item">
                            <p>收件人：<span>{{index.recipients}}</span>
                            <el-button class="butcolor" @click="editorAddr(index)">编辑</el-button>
                            </p>
                            <p>电话：<span>{{index.phone}}</span>
                            <el-button class="butcolor" @click="deleteAddress(index.id)">删除</el-button>
                            </p>
                            <p><span class="addressleft">收货地址：</span><span class="addressright">{{index.sheng+index.shi+index.xian+index.area}}</span>
                            <el-button v-if="index.status === 0" class="butcolor" @click="defaultAddress(index.id)">设为默认</el-button>
                            <el-button v-if="index.status === 1" class="butcolor" >已选默认</el-button>
                            </p>
                            <p>邮编：<span>{{index.postcode}}</span></p>
                        </el-card>
                        <el-button class="butcolor" @click="showCreateAddress()" style="margin-top:50px;width:150px">+ 添加新地址</el-button>
                        </div>
                    </div>
                    </el-tab-pane>
                    <el-tab-pane label="我的订单" name="orderslist">
                    <!-- pc端显示 -->
                    <div>
                      <el-tabs class="tabs" type="card" value="all" @tab-click="selectTab">
                        <el-tab-pane :label="index==0?'全部订单':index==1?'已完成订单':'未完成订单'" :name="index==0?'all':''" v-for="(item,index) in [allOrder,completeOrder,unfinishedOrder]" :key="index">
                          <el-table :data="item" style="width: 100%">
                            <el-table-column prop="order_num" label="订单编号" width="180"></el-table-column>
                            <el-table-column prop="order_time" label="下单日期" width="180"></el-table-column>
                            <el-table-column prop="total_price" label="总价"></el-table-column>
                            <el-table-column prop="order_status_label" label="订单状态"></el-table-column>
                            <el-table-column label="订单详情">
                                <template slot-scope="scope">
                                <el-button @click.native.prevent="orderDetails(scope.row.order_num,scope.row.id)" type="text" size="small">订单详情</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="订单操作">
                                <template slot-scope="scope">
                                <el-button v-if="index!=1 && scope.row.order_status === 1" @click.native.prevent="cancelOrder(scope)" type="text" size="small">取消订单</el-button>
                                <el-button v-if="index!=1 && scope.row.order_status === 2" type="text" size="small">待收货</el-button>
                                <el-button v-if="scope.row.order_status === 3" @click.native.prevent="buyAgain(scope)" type="text" size="small">再次购买</el-button>
                                <el-button v-if="index!=1 && scope.row.order_status === 4" @click.native.prevent="buyAgain(scope)" type="text" size="small">再次购买</el-button>
                                </template>
                            </el-table-column>
                          </el-table>
                        </el-tab-pane>
                      </el-tabs>
            </div>
            </el-tab-pane>
        </el-tabs>
        </div>
          </div>
      </div>
    <div class="navaddress hidden-sm-and-down">
      <!--   新增收货地址   -->
      <el-dialog :title="istitle" :visible.sync="addAddressForm" center :before-close="resetForm" :close-on-click-modal="false">
        <el-form :model="recipient" size="mini" :rules="rules" ref="recipient" label-width="100px" class="demo-ruleForm" @submit.native.prevent>
          <el-form-item label="收件人" prop="name">
            <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model="recipient.name" placeholder="请输入收货人姓名"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="tel">
            <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" v-model.number="recipient.tel" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="所在省市" prop="sheng" class="city">
            <el-select v-model="recipient.sheng" @change="choseProvince" placeholder="省级地区">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select v-model="recipient.shi" @change="choseCity" :placeholder="shi">
              <el-option v-for="item in shi1" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select v-model="recipient.qu" @change="choseBlock" :placeholder="qu">
              <el-option v-for="item in qu1" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" prop="addressDetails">
            <el-input v-model="recipient.addressDetails" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item label="邮编" prop="Zipcode">
            <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" v-model="recipient.Zipcode" placeholder="请输入邮编"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm" style="background: #00383F;border-color: #00383F;color:#fff; ">取消</el-button>
          <el-button type="primary" @click="recipientSubmitForm('recipient')" style="background: #00383F;border-color: #00383F;color:#fff;border-radius: 5px;">保存</el-button>
        </div>
      </el-dialog> 
      <el-dialog title="修改地址" :visible.sync="editorAddressForm" center :close-on-click-modal="false">
        <el-form :model="edit_recipient" size="mini" :rules="rules" ref="edit_recipient" label-width="100px" class="demo-ruleForm" @submit.native.prevent>
          <el-form-item prop="id" style="display: none">
            <el-input v-model="edit_recipient.id"></el-input>
          </el-form-item>
          <el-form-item label="收件人" prop="recipients">
            <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model="edit_recipient.recipients" placeholder="请输入收货人姓名"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" v-model="edit_recipient.phone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="所在省市" prop="sheng" class="city">
            <el-select v-model="edit_recipient.sheng" @change="choseProvince" placeholder="省级地区">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select v-model="edit_recipient.shi" @change="choseCity" :placeholder="shi">
              <el-option v-for="item in shi1" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-select v-model="edit_recipient.xian" @change="choseBlock" :placeholder="qu">
              <el-option v-for="item in qu1" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址" prop="area">
            <el-input v-model="edit_recipient.area" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item label="邮编" prop="postcode">
            <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" v-model="edit_recipient.postcode" placeholder="请输入邮编"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editorAddressForm = false" style="background: #00383F;border-color: #00383F;color:#fff; ">取消</el-button>
          <el-button type="primary" @click="postEditAddress('edit_recipient',edit_recipient)" style="background: #00383F;border-color: #00383F;color:#fff;border-radius: 5px;">保存</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 手机端显示 -->
    <div class="hidden-md-and-up">
        <div class="brandtab">
            <ul>
                <li @click="cur=0"><span >我的信息</span><i :class="{actives:cur==0}"></i></li>
                <li @click="cur=1"><span >收货地址</span><i :class="{actives:cur==1}"></i></li>
                <li @click="cur=2"><span >我的订单</span><i :class="{actives:cur==2}"></i></li>
            </ul>
        </div>
        <div class="tab-content">
          <!-- 我的信息 -->
            <div v-if="cur==0" class="userform">
                  <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
                    <div class="lableName">
                      <p>称谓</p><span class="el-icon-arrow-down"></span>
                    </div>
                    <el-form-item prop="userName">
                      <el-input type="text" v-model="ruleForm.userName" ref="name" autocomplete="off"></el-input>
                    </el-form-item>
                      <div class="lableName">
                      <p>性别</p><span class="el-icon-arrow-down"></span>
                    </div>
                    <el-form-item rop="gender">
                    <el-radio-group v-model="ruleForm.gender" ref="gender">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                    </el-form-item>
                      <div class="lableName">
                      <p>生日</p><span class="el-icon-arrow-down"></span>
                    </div>
                    <el-form-item >
                    <div class="block">
                        <el-date-picker v-model="ruleForm.birthday" type="date" placeholder="选择日期" :editable="false" value-format="yyyy-MM-dd" ref="birthday" style="width:100%"></el-date-picker>
                    </div>
                    </el-form-item>
                    <el-form-item prop="email">
                    <el-input type="email" v-model="ruleForm.email" autocomplete="off" ref="email"></el-input>
                    </el-form-item>
                      <el-form-item>
                    <el-input v-model="ruleForm.userPhone" autocomplete="off" :disabled="true"></el-input>
                    </el-form-item>
                    <div  v-on:click="submitForm(formData)" class="subbutton">提交</div>
                    <p class="aut" v-on:click="outlogin()">退出登录</p>
                </el-form>
            </div>
            <!-- 我的收货地址 -->
            <div v-if="cur==1" class="site">
              <div class="sitebox" v-show="addressData.length<=0" >
                +您当前没有任何收货地址
              </div>
              <div v-for="(index,item) in addressData" :key="item">
                <div class="sitelist">
                  <p>{{index.sheng + '&nbsp;' +index.shi +'&nbsp;'+ index.xian + index.area}} {{index.recipients}}{{index.phone}} </p>
                  <a class="bianji1" href="#"><img src="../../static/mobile/bianji.png" alt="" @click="edithadle(index)"></a>
                </div>
                <div class="handle">
                  <input type="checkbox" class="tui-checkbox"  @click = "handleclick(index.id)" :checked="index.status==1"  :value="index.status" v-model="index.status"><span>设为默认地址</span>
                  <p @click="deleteAddress(index.id)">删除</p>
                </div>
              </div>
              <div class="handlecity">
                <router-link style="display: inline-block;width:100%" :to="{ name:'Addcity', query: {id: 1} }"> 添加地址 <img src="../../static/mobile/bianji2.png" alt=""></router-link>
              </div>
            </div>
            <div v-if="cur==2">
                  <div class="ordertab">
                      <ul>
                        <li @click="curs=index" v-for="(item,index) in ['全部订单','已完成订单','未完成订单']" :key="index">
                          <span>{{item}}</span>
                          <i :class="{actives:curs==index}"></i>
                        </li>
                      </ul>
                  </div>
                  <div class="ordercontent">
                    <div v-show="curs==indexs" v-for="(items,indexs) in [allOrder,completeOrder,unfinishedOrder]" :key="indexs">
                      <div class="moblist" v-for="(item,index) in items" :key="index">
                        <div class="allorder">
                          <div class="orderlft">
                            <div>
                                <img :src="imgsrc + item.product[0].cover" alt="">
                            </div>
                            <span>总计:￥{{ item.total_price }}</span>
                          </div>
                          <div class="orderrig">
                            <p>交易状态:{{ item.order_status_label }}</p>
                            <p>下单时间:{{ item.order_time }}</p>
                            <p>订单编号:{{ item.order_num }}</p>
                            <div class="btnbox">
                              <div v-if="item.order_status === 1" @click="AutOrder(item.id)">取消订单</div>
                              <div v-if="item.order_status === 2">待收货</div>
                              <div v-if="item.order_status === 3">已完成</div>
                              <div v-if="item.order_status === 4">已取消</div>
                              <!-- <div v-if="item.order_status === 6">已退款</div> -->
                              <div @click="orderDetails(item.order_num,item.id)">订单详情</div>
                            </div>
                          </div>
                        </div>
                        <div style="width:90%;height:1px;background: rgba(0, 56, 63, 0.5);margin:0 auto"></div>
                      </div>
                    </div>
                  </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
  import {regionData} from 'element-china-area-data';
  import { logout_url,get_user_info_url,get_address_url,save_user_info_url,del_address_url,orders_url,default_Address_url,complete_orders_url,get_unfinished_orders_url,create_address_url,edit_address_url,quit_order_url } from '../request/api'

  export default {
    name: "information",
    data() {
      // 我的信息form
      let validatePhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("号码不能为空！"));
        } else {
          const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[389])\d{8}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error("请输入正确的手机号"));
          }
        }
      };
      let validateName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("姓名不能为空！"));
        } else {
          const reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error("格式不正确"));
          }
        }
      };
      let validateEmail = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("邮箱不能为空！"));
        } else {
          const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error("邮箱格式不正确"));
          }
        }
      };
      let recipientZipCode = (rule, value, callback) => {
        if (!value) {
          // return callback(new Error('邮编不能为空！'))
          callback();//邮编可为空
        } else {
          const reg = /^[0-9][0-9]{5}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('邮政编码格式不正确！'));
          }
        }
      };

      return {
        cur:0,
        curs:0,
        checked:'',
        istitle:'新增地址',
        orderslist:'myinfo',
        allOrder: [],
        completeOrder: [],
        unfinishedOrder: [],
        options: regionData,
        cityIndex: 0,
        xianIndex: 0,
        shi: '市级地区',
        qu: '县级地区',
        shi1: [],
        qu1: [],
        formData: '',
        addressData: [],
        addAddressForm: false,
        editorAddressForm: false,
        // 我的信息form
        ruleForm: {
          userPhone: '',
          gender: '',
          userName: "",
          birthday: '',
          email: ""
        },
        rules: {
          userName: [{validator: validateName, trigger: "blur"}],
          email: [{validator: validateEmail, trigger: "blur"}],
          name: [
            {required: true, message: '请输入收货人姓名', trigger: 'blur'},
            {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
          ],
          recipients: [
            {required: true, message: '请输入收货人姓名', trigger: 'blur'},
            {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
          ],
          tel: [
            {required: true, validator: validatePhone, trigger: 'blur'},
            { type: 'number', message: '电话必须为数字'}
          ],
          phone: [
            {required: true, validator: validatePhone, trigger: 'blur'},
          ],
          sheng: [
            {required: true, message: '请选择收货地址', trigger: 'change'},
          ],
          addressDetails: [
            {required: true, message: '请输入详细地址', trigger: 'blur'},
            {min: 3, max: 99, message: '长度在 3 到 99 个字符', trigger: 'blur'}
          ],
          area: [
            {required: true, message: '请输入详细地址', trigger: 'blur'},
            {min: 3, max: 99, message: '长度在 3 到 99 个字符', trigger: 'blur'}
          ],
          Zipcode: [
            {required: false, validator: recipientZipCode, trigger: 'blur'},
          ],
          postcode: [
            {required: false, validator: recipientZipCode, trigger: 'blur'},
          ],
        },
        //添加收货地址
        recipient: {
          name: '',
          tel: '',
          city: '',
          addressDetails: '',
          Zipcode: '',
          sheng: '',
          shi: '',
          qu: '',
          E: '',
        },
        edit_recipient: {
          id: '',
          recipients: '',
          phone: '',
          area: '',
          postcode: '',
          sheng: '',
          shi: '',
          xian: '',
          E: '',
          status:0,
        },
        value2: "",
      };
    },
    
    methods: {
      handleclick(id){
           default_Address_url({id:id}).then((res)=>{
              this.getAddress()
              if(this.$route.query.city == 2){
                this.$router.push({path:'/ordersIn?page=s'})
              }
           })
        
      },
      //退出登录
      outlogin(){
        logout_url().then((res) => {
          localStorage.removeItem("userToken");
          this.$store.dispatch("setLogin", false);
          this.$store.dispatch("setCarCount", 0);
          this.$message.success(res.data.message);
          this.$router.push({ path: "/Login" });
        });
      },
      // 我的信息form
      submitForm() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            const postParams = {
              name: this.$refs.name.value,
              gender: this.$refs.gender.value,
              birthday: this.$refs.birthday.value,
              email: this.$refs.email.value
            };
            this.saveUserInfo(postParams);
          } else {
            this.$message.success('请输入完整信息');
            return false;
          }
        });
      },
      saveUserInfo(params) {
        //提交用户信息
        save_user_info_url(params).then((res)=>{
            if (res.status === 200) this.$message.success('操作成功')          
        })
        
      },
        deleteAddress(id) {
        del_address_url({detele_id: id}).then((res)=>{
          this.getAddress()
        })
       
      },
      // 设置默认地址
      defaultAddress(id) {
        default_Address_url({id:id}).then((res)=>{
          this.getAddress()
        })
      },
      //获取订单
        getOrders() {
        orders_url().then((res)=>{
             this.allOrder = res.data.data;
        })
      },
        getCompleteOrders() {
        complete_orders_url().then((res)=>{
           this.completeOrder = res.data.data;
        })
        
      },
        getUnfinishedOrders() {
        get_unfinished_orders_url().then((res)=>{
            this.unfinishedOrder = res.data.data;
        })
       
      },
        getShipAddress() {
        get_address_url().then((res)=>{
            this.addressData = res.data.data;
        })
       
      },
        getUserInfo() {
        get_user_info_url().then((res)=>{
          console.log(res)
            this.ruleForm.userPhone = res.data.data[0].phone;
            this.ruleForm.userName = res.data.data[0].user.name;
            this.ruleForm.gender = res.data.data[0].user.gender;
            this.ruleForm.birthday = res.data.data[0].user.birthday;
            this.ruleForm.email = res.data.data[0].user.email;
        })
     
      },
      // 提交收货地址form
      recipientSubmitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (!this.$store.state.isLogin) {
              this.$router.push({path: '/login'});
            } else {
              let addressdata = {
                recipients: this.recipient.name,
                phone: this.recipient.tel,
                sheng: this.recipient.sheng,
                shi: this.recipient.shi,
                xian: this.recipient.qu,
                area: this.recipient.addressDetails,
                postcode: this.recipient.Zipcode,
              };
              this.createAddress(addressdata);
            }
          } else {
            return false;
          }
        });
      },
      showCreateAddress() {
            this.recipient.name = '';
            this.recipient.tel = '';
            this.recipient.sheng = '';
            this.recipient.shi = '';
            this.recipient.qu = '';
            this.recipient.addressDetails = '';
            this.recipient.Zipcode = '';
            this.shi1 = '';
            this.qu1 = '';
            this.recipient.E = '';
            this.addAddressForm = true;

      },
      //创建地址
      createAddress(addressInfo) {
        create_address_url(addressInfo).then((res)=>{
            this.getAddress();
            this.recipient.name = '';
            this.recipient.tel = '';
            this.recipient.sheng = '';
            this.recipient.shi = '';
            this.recipient.qu = '';
            this.recipient.addressDetails = '';
            this.recipient.Zipcode = '';
            this.shi1 = '';
            this.qu1 = '';
            this.recipient.E = '';

            this.$refs['recipient'].resetFields();
            this.addAddressForm = false;
        })
    
      },
      //修改地址
        editAddress(data) {
        edit_address_url(data).then((res)=>{
            if (res.data.code === 200) {
                this.$message.success('修改成功');
              this.editorAddressForm = false;
              this.getAddress();
            }else{
              this.$message.error('保存失败')
            }
        })
   
      },
        postEditAddress(formName,data) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (!this.$store.state.isLogin) {
              this.$router.push({path: '/login'});
            } else {
              this.editAddress(data)
            }
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      },
      //取消
      resetForm() {
        this.recipient.sheng = this.shi1 = this.recipient.shi = this.qu1 = this.recipient.qu = this.recipient.E = '';
        this.$refs['recipient'].resetFields();
        this.addAddressForm = false;
      },
      editorAddr(data) {
        for (let edit2 in this.options) {
          if (data.sheng === this.options[edit2].label) {
            this.shi1 = this.options[edit2].children;
            if (this.shi1 != undefined) {
              for (let edit3 in this.shi1) {
                if (data.shi === this.shi1[edit3].label) {
                  this.qu1 = this.options[edit2].children[edit3].children;
                  if (this.qu1 == undefined) {
                    this.edit_recipient.E = this.edit_recipient.xian = '';
                    this.qu = '下方输入详细地址'
                  }
                }
                this.xianIndex = edit3;
              }
            } else {
              this.edit_recipient.E = this.edit_recipient.xian = this.edit_recipient.shi = '';
              this.shi = this.qu = '下方输入详细地址'
            }
            this.cityIndex = edit2;
          }
        }
        this.edit_recipient.id = data.id;
        this.edit_recipient.recipients = data.recipients;
        this.edit_recipient.phone = data.phone;
        this.edit_recipient.sheng = data.sheng;
        if(data.shi=='_'){
          this.recipient.shi = this.edit_recipient.shi = '';
          this.shi = '下方输入详细地址'
        }else {
          this.edit_recipient.shi = data.shi;
        }
        if(data.xian=='_'){
          this.recipient.E = this.recipient.qu = this.edit_recipient.E = this.edit_recipient.xian = '';
         this.qu = '下方输入详细地址'
        }else {
          this.edit_recipient.xian = data.xian;
        }
        this.edit_recipient.area = data.area;
        this.edit_recipient.postcode = data.postcode;

        this.editorAddressForm = true;
      },
      // 选省
      choseProvince: function (e) {
        for (let index2 in this.options) {
          if (e === this.options[index2].value) {
            this.recipient.sheng = this.options[index2].label;
            this.edit_recipient.sheng = this.options[index2].label;
            this.shi1 = this.options[index2].children;
            if (this.shi1 != undefined) {
              this.recipient.shi = this.options[index2].children[0].label;
              this.edit_recipient.shi = this.options[index2].children[0].label;
              this.qu1 = this.options[index2].children[0].children;
              if (this.qu1 != undefined) {
                this.recipient.qu = this.options[index2].children[0].children[0].label;
                this.edit_recipient.xian = this.options[index2].children[0].children[0].label;
                this.recipient.E = this.qu1[0].value;
              } else {
                this.recipient.E = this.recipient.qu = '';
                this.edit_recipient.E = this.edit_recipient.qu = '';
                this.qu = '下方输入详细地址'
              }
            } else {
              this.recipient.E = this.recipient.qu = this.recipient.shi = '';
              this.edit_recipient.E = this.edit_recipient.xian = this.edit_recipient.shi = '';
              this.shi = this.qu = '下方输入详细地址'
            }
            this.cityIndex = index2;
          }
        }
      },
      // 选市
      choseCity: function (e) {
        for (var index3 in this.options[this.cityIndex].children) {
          if (e === this.options[this.cityIndex].children[index3].value) {
            this.recipient.shi = this.options[this.cityIndex].children[index3].label;
            this.edit_recipient.shi = this.options[this.cityIndex].children[index3].label;
            this.qu1 = this.options[this.cityIndex].children[index3].children;
            if (this.qu1 != undefined) {
              this.recipient.qu = this.options[this.cityIndex].children[index3].children[0].label;
              this.edit_recipient.xian = this.options[this.cityIndex].children[index3].children[0].label;
              this.recipient.E = this.qu1[0].value;
            } else {
              this.recipient.E = this.recipient.qu = '';
              this.edit_recipient.E = this.edit_recipient.xian = '';
              this.qu = '下方输入详细地址'
            }
            this.xianIndex = index3;
          }
        }
      },
      // 选区
      choseBlock: function (e) {
        for (var index4 in this.options[this.cityIndex].children[this.xianIndex].children) {
          if (e === this.options[this.cityIndex].children[this.xianIndex].children[index4].value) {
            this.recipient.qu = this.options[this.cityIndex].children[this.xianIndex].children[index4].label;
            this.edit_recipient.xian = this.options[this.cityIndex].children[this.xianIndex].children[index4].label;
          }
        }
      },
      //请求收货地址数据
        getAddress() {
         get_address_url().then((res)=>{
               if (res.data.data.length === 0) {
                this.addressData = [];
                } else {
                this.addressData = res.data.data;
                }
        })
    
      },
      buyAgain(params) {
        this.$router.push({
          name: 'index',
        });
      },
      payment(params){

      },
      cancelOrder(params) {
        let _self = this;
        this.$confirm('此操作将取消订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _self.postCancelOrder({id: `${params.row.id}`});
        }).catch(() => {

        });
      },
      AutOrder(params){
        this.postCancelOrder({id: params});
      },
        postCancelOrder(params) {
        quit_order_url(params).then((res=>{
        if (res.data.code === 200) this.$message.success('成功取消');
        //获取订单
        this.getOrders();
        // 未完成订单
        this.getUnfinishedOrders();
        }))
        
      },
      orderDetails(orderNum,id) {
        this.$cookies.set('ordersId', id)
        this.$router.push({name:'Orders_i',params:{id:id}})
      },
      // 手机端修改地址
      edithadle(Citylist){
          this.$cookies.set('Citylist', Citylist)
          this.$router.push({path:'/Addcity',query:{id:2}})
      },
      selectTab(tab, event) {
        // this.$store.dispatch('resizeWindow');//页面高度自适应
      },
    },
    mounted() {
      if(this.$route.query.id=='orderslist'){
        this.orderslist=this.$route.query.id
        this.cur = 2
      }
      if(this.$route.query.id == 1){
        this.cur = this.$route.query.id
      } 
      // 用户订单列表
      if (!this.$store.state.isLogin) {
        this.$router.push({path: "/login"});
      } else {
        //获取订单
        this.getOrders();

        // 已完成订单
        this.getCompleteOrders();

        // 未完成订单
        this.getUnfinishedOrders();

        // 收货地址
        this.getShipAddress();

        //获取用户信息
        this.getUserInfo();
      }
      if (!this.$store.state.isLogin) {
        this.$router.push({path: "/login"});
      }
    }
  };
</script>
<style lang="less" scoped>

/deep/.el-radio__inner{
  background-color: unset!important;
}
/deep/.el-radio__inner {
    border: 1px solid #00383F!important;
}
/deep/.el-radio__inner::after{
      width: 10px!important;
    height: 10px!important;
    border-radius: 100%!important;
    background-color: #00383F!important;
}
/deep/.el-radio__input.is-checked+.el-radio__label{
  color:#00383F!important;
}
/deep/ .el-tabs--card>.el-tabs__header {
    border-bottom: 1px solid  rgba(0, 56, 63, 0.5);
}
/deep/.information .container .tabs{
  border-bottom: 1px solid #00383f!important;
}
/deep/.el-button:focus, .el-button:hover {
    color: #fff!important;
    border-color: unset!important;
    background-color: #00383F!important;
}
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item:first-child{
  border-left: none!important;
}
/deep/.el-tabs--card>.el-tabs__header .el-tabs__nav {
    border: 1px solid #00383F;
    border-radius:unset;
}
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item{
  border-left: 1px solid #00383F!important;
}
/deep/.el-table tr{
  background-color:unset!important;
}
/deep/.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
  border-bottom: 1px solid #00383f!important;
}
/deep/.el-table th.el-table__cell{
  background: unset!important;
}
/deep/.el-input__inner{
     background: #F5F7FA;
  }
  /deep/.el-tabs__item.is-active, .information .el-tabs__item:hover{
      background: #00383F;
  }
 /deep/.el-tabs__item:hover{
     color: unset;
 }
  /deep/el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #00383F!important;
  }
  /deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #00383F;
    color: #fff;
}
/deep/.el-radio__input.is-checked .el-radio__inner{
        border-color: #00383F;
    background: unset!important;
}
/deep/.el-radio__label{
    color: #00383F;
    font-size: 18px;
}
/deep/.el-input__inner{
     color: #00383F!important;
}
/deep/.el-card{
    border: 1px solid #00383F;
    background-color:unset!important;
    margin-top: 5%;
}
/deep/.el-card__body{
  padding: 3%;
}
.butcolor{
  background:#00383F;
  color: #fff;
}
/deep/  .el-dialog{
    width: 30%;
  }
/deep/.tabs.el-tabs--card > .el-tabs__header{
  border-bottom: unset!important;
}
 
.information{
  
       width: 100%;
        color: #00383F;
        .container{
            width: 80%;
               max-width: 1300px;
               margin: 0 auto;
            .demo-ruleForm{
                max-width: 400px;
                margin: 0 auto;
                .subbutton{
                    width: 27%;
                    padding: 3% 0;
                    background: #00383F;
                    color: #fff;
                    font-weight: 600;
                }
            
            }
            .box-card{
         
                  p{
                        height: 15px;
                        line-height: 15px;
                        padding: 2% 0;
                        text-align: left;
                        border-bottom: 1px solid #00383F;
                        font-size: 20px;
                        color: #00383F;
                  }
                  .el-button {
                    background:#00383F;
                    float: right;
                    color: #fff;
                    padding: 1%;
                    border-bottom: unset;
                    border-radius:unset;
                    margin-top: 1px;
                  }
              
            
            }
         .tabs{
           text-align: center;
                .el-button--text {
                  width: 75px;
                    height: 40px;
                  text-align: center;
                    background:#00383F;
                    color: #fff;
                    padding: 1%;
                    border-bottom: unset;
                    border-radius:unset;
                    margin-top: 1px;
                  }
         }

       
        }
}

 @media (max-width: 991px) {
 .brandtab{
         height: 1.14rem;
         border-bottom: 1px solid #00383F;
         ul{
             display: flex;
             width: 100%;
             height: 1.13rem;
             li{
                 width: 33.3%;
                 font-size: 0.34rem;
                 font-weight: 900;
                 position: relative;
                 span{
                    display: inline-block;
                     padding-top: 0.52rem;
                     width: 1.7rem;
                  
                 }
                     .actives{
                        display: inline-block;
                        display: inline-block;
                        width: 1.49rem;
                        height: 0.06rem;
                        background:#00383F ;
                        position: absolute;
                        bottom: -0.01rem;
                        left: 50%;
                        transform: translateX(-50%);
                        }
                 
             }
         }
     }
// 订单tab
.ordertab{
  height: 1.09rem;
  border-bottom: 1px solid #00383F;
  width: 95%;
  margin: 0 auto;
  ul{
      display: flex;
      width: 100%;
       height: 1.09rem;
       li{
          width: 33.3%;
          font-size: 0.3rem;
          font-weight: 900;
          position: relative;
          span{
            display: inline-block;
            padding-top: 0.52rem;
            width: 1.7rem;
          }
        .actives{
            display: inline-block;
            display: inline-block;
            width: 1.49rem;
            height: 0.06rem;
            background:#00383F ;
            position: absolute;
            bottom: -0.01rem;
            left: 50%;
            transform: translateX(-50%);               

            }
      }
  }
}
.ordercontent{
  // .moblist{background: url(../../static/detail2.png) no-repeat center center/100% 100%;}
  .allorder{
    overflow: hidden;
    padding: 0.6rem 0.8rem;
    //  padding: 0 0.8rem;
    display: flex;
    .orderlft{
      width:23%;
      float: left;
      div{  
        width: 1.367rem;
        height: 2rem;
        background: url(../../static/mobile/product.png) no-repeat;
        background-size: 100% 100%;
        border: 1px solid #00383F ;
          img{
          width: 100%;
          padding-top: 0.27rem;
        }
      }
      span{
        display: inline-block;
        width: 100%;
        font-size: 0.19rem;
        text-align: left;
        margin-top: 0.62rem;
        font-weight: bold;
      }
    }
    .orderrig{
      width: 70%;
      float: left;
      text-align: left;
      margin-left: 7%;
      p{
        font-size: 0.24rem;
        font-weight: bold;
        color: #00383F;
      }
      p:nth-child(1){
        font-size: 0.3rem;
        padding-top: 0.19rem;
      }
        p:nth-child(2){
          padding: 0.32rem 0 0.3rem 0;
      }
      .btnbox{
        overflow: hidden;
        margin-top: 0.68rem;
        div{
          width: 1.2rem;
          height: 0.4rem;
          background: #00383F;
          color: #fff;
          text-align: center;
          line-height: 0.4rem;
          float: right;
          font-size: 0.22rem;
        }
        div:nth-child(2){
          margin-right: 0.3rem;
        }
      }
    }
  }
}

     .userform{
       margin: 0 0.4rem;
       padding-top: 0.89rem;
       .lableName{
         height: 0.9rem;
         border: 1px solid #00383F;
         margin-bottom: 0.2rem;
         font-size: 0.3rem;
         font-weight: 900;
         line-height: 0.9rem;
         padding: 0 0.21rem;
         p{
           display: inline-block;
          float: left;
         }
         span{
           float: right;
           line-height: 0.9rem;
           font-size: 0.36rem;
         }
       }
       .el-form-item {
         height: 0.9rem;
         border: 1px solid #00383F;
         margin-bottom: 0.21rem!important;
         /deep/.el-input__inner {
           height: 0.9rem!important;
           border: unset!important;
           padding: 0 0.21rem;
           font-size: 0.3rem;
         }
         /deep/.el-radio-button__inner, .el-radio-group{
           float: left;
           line-height: 0.9rem;
           padding: 0 0.21rem;
         }
         /deep/.el-radio__label{
           font-size: 0.3rem;
           vertical-align: bottom;
         }
         /deep/.el-radio__inner{
           width: 0.27rem;
           height: 0.27rem;
         }
         /deep/.el-input__prefix{
           display: none;
         }
         /deep/.el-radio__inner::after{
           width: 0.1rem!important;
           height: 0.1rem!important;
         }
         /deep/.el-radio{
           line-height: 0.9rem;
         }
 
       }
           .subbutton{
           width: 100%;
           height: 0.9rem;
           background: #00383F;
           color: #fff;
           font-size: 0.36rem;
           line-height: 0.9rem;
         }
         .aut{
           font-size: 0.36rem;
            font-weight: 900;
            padding-top: 0.3rem;
            padding-bottom: 1.9rem;
         }
     }
     .site{
         margin: 0 0.3rem;
 /deep/.el-checkbox__inner::after {
          border: 0.02rem solid #00383F;
          border-left: 0;
          border-top:0;
          width: 0.16rem;
          height: 0.3rem;
          left: 0.1rem;
          top: 0.01rem;
    }
    /deep/.el-checkbox__inner{
      width: 0.4rem;
      height: 0.4rem;
    }
    /deep/.el-checkbox__label{
      font-size: 0.3rem;
      color: #00383F;
      font-weight: 900;
      vertical-align: middle;
    }
    /deep/.el-checkbox{
      float: left;
    }
       .sitebox{
         width: 100%;
         height: 1.7rem;
         line-height: 1.7rem;
         border: 1px solid #00383F;
         margin-top: 0.89rem;
         font-size: 0.4rem;
         font-weight: 900;
        color: #00383F;
       }
       .sitelist{
          height: 1.7rem;
          border: 1px solid #00383F;
          margin-top: 0.4rem;
          font-size: 0.4rem;
          font-weight: 900;
          color: #00383F;
           font-size: 0.24rem;
          text-align: left;
          padding: 0 0.49rem;
          position: relative;
          p{
            max-width: 4.95rem;
            min-height: 0.55rem;
            padding-top: 0.59rem;
          }
      
         .bianji1{
           position: absolute;
           right: 0.49rem;
           top: 0.66rem;
           width: 0.39rem;
           display: inline-block;
           img{
             width: 100%;
           }
         }
         
       }
       .handle{
           font-size: 0.3rem;
          font-weight: 900;
          overflow: hidden;
          padding: 0.19rem 0 0.29rem 0;
          border-bottom: 1px solid rgba(0, 56, 63, 0.5);;
          text-align: left;
          position: relative;
               input[type="checkbox"]{width:0.4rem;height:0.4rem;display: inline-block;text-align: center;vertical-align: middle; line-height: 18px;position: relative;}
              input[type="checkbox"]::before{content: "";position: absolute;top: 0;left: 0;background: #fff;width: 100%;height: 100%;border: 1px solid #00383F}
              input[type="checkbox"]:checked::before{content: '';width: 0.4rem;height: 0.4rem;background:#fff url("../../static/mobile/duihao.png") no-repeat;background-size: 0.4rem 0.4rem;}
              p{
                position: absolute;
                right: 0;
                top: 0.19rem;
              }
              span{
                margin-left: 0.19rem;
                vertical-align: middle;
              }
         }
         .handlecity{
           font-size: 0.48rem;
           font-weight: 900;
           text-align: left;
           overflow: hidden;
           padding-top: 0.2rem;
           padding-bottom: 1rem;
           img{
             float: right;
             width: 0.44rem;
             padding-top: 0.1rem;
           }
         }
     }
 }
</style>


// WEBPACK FOOTER //
// src/view/Information.vue